import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { InterventionInvoicePrice } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/intervention-price`;

export const getInterventionPrice = (
    productId: string, date: string, source: CancelTokenSource): Promise<InterventionInvoicePrice> => {

  const formData = new FormData();
  formData.append("productId", productId);
  formData.append("date", date);

  return axios
      .post(`${apiUri}`, formData, {cancelToken: source.token})
      .then((response) => response.data);
};
